<!-- Midden -->
<main role="main">
  <section>
    <article>
      <header
        class="section background-green-hightlight background-transparent text-center background-blue"
        data-parallax="scroll"
        data-image-src="../../../assets/images/parallax-06.jpg"
      >
        <h1
          class="text-white margin-bottom-0 text-size-50 text-thin text-line-height-1 text-s-size-16"
        >
          Aanbiedingen fabrikanten&nbsp;
        </h1>
      </header>
      <div class="section background-white padding">
        <div class="line">
          <!-- Catalogus -->

          <div class="line">
            <p class="icon-home text-blue">
              <a routerLink="/NL/home"> Home</a>
            </p>
            <h4
              class="text-size-16 text-s-size-12 icon-mfg_icon_circle text-red icon-eye"
            >
              <a
                href="https://view.publitas.com/providental/promo-web-nl-providental"
                target="_blank"
              >
                <strong><em> Promotie Providental</em></strong>
              </a>
            </h4>
            <hr class="break break-small background-primary" />
            <div class="box margin-bottom">
              <div class="margin">
                <!-- CONTENT -->

                <!-- ASIDE NAV -->
                <div class="s-12 m-8 l-12">
                  <div class="line">

                    <div class="s-12 m-6 l-3 margin-top-30">
                      <a
                        href="../../../assets/images/Aanbiedingen fabrikanten/GC promo Q1 2026.pdf"
                        target="_blank"
                        ><img
                          src="../../../assets/images/Aanbiedingen fabrikanten/gc afb web nl.png"
                          alt="GC"
                          width="157"
                          height="220"
                          class="center"
                      /></a>
                      <div>
                        <h5 class="text-uppercase text-strong text-center">
                          GC
                        </h5>
                        <p>
                          <a
                            class="text-more-info text-aqua-hover text-center"
                            href="../../../assets/images/Aanbiedingen fabrikanten/GC promo Q1 2026.pdf"
                            target="_blank"
                            >tot 31/03/2026</a
                          >
                        </p>
                      </div>
                    </div>

                    <div class="s-12 m-6 l-3 margin-top-30">
                      <a
                        href="../../../assets/images/Aanbiedingen fabrikanten/Coltene promo tot eind maart 26 NL.pdf"
                        target="_blank"
                        ><img
                          src="../../../assets/images/Aanbiedingen fabrikanten/coltene afb web nl.png"
                          alt="Coltene"
                          width="157"
                          height="220"
                          class="center"
                      /></a>
                      <div>
                        <h5 class="text-uppercase text-strong text-center">
                          Coltene
                        </h5>
                        <p>
                          <a
                            class="text-more-info text-aqua-hover text-center"
                            href="../../../assets/images/Aanbiedingen fabrikanten/Coltene promo tot eind maart 26 NL.pdf"
                            target="_blank"
                            >tot 31/03/2026</a
                          >
                        </p>
                      </div>
                    </div>

                    <div class="s-12 m-6 l-3 margin-top-30">
                      <a
                        href="../../../assets/images/Aanbiedingen fabrikanten/Voco promo 2025 Engels mei.pdf"
                        target="_blank"
                        ><img
                          src="../../../assets/images/Aanbiedingen fabrikanten/voco afb web nl.png"
                          alt="Voco"
                          width="157"
                          height="220"
                          class="center"
                      /></a>
                      <div>
                        <h5 class="text-uppercase text-strong text-center">
                          Voco
                        </h5>
                        <p>
                          <a
                            class="text-more-info text-aqua-hover text-center"
                            href="../../../assets/images/Aanbiedingen fabrikanten/Voco promo 2025 Engels mei.pdf"
                            target="_blank"
                            >Highlights VOCO</a
                          >
                        </p>
                      </div>
                    </div>

                    <div class="s-12 m-6 l-3 margin-top-30">
                      <a
                        href="../../../assets/images/Aanbiedingen fabrikanten/My Lunos 2024 NL.pdf"
                        target="_blank"
                        ><img
                          src="../../../assets/images/Aanbiedingen fabrikanten/Durr dental web nl.png"
                          alt="Durr dental"
                          width="157"
                          height="220"
                          class="center"
                      /></a>
                      <div>
                        <h5 class="text-uppercase text-strong text-center">
                          Durr dental
                        </h5>
                        <p>
                          <a
                            class="text-more-info text-aqua-hover text-center"
                            href="../../../assets/images/Aanbiedingen fabrikanten/My Lunos 2024 NL.pdf"
                            target="_blank"
                            >Nieuw in assortiment</a
                          >
                        </p>
                      </div>
                    </div>

                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Kleurbalk -->
      <div class="background-dark padding text-center"></div>
    </article>
  </section>
</main>
